import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function BudgetrequestReducer(state = initialState.project, action: any) {
  switch (action.type) {
    case types.SAVE_PROJECT_SUCCESS:
      return action.project;
    default:
      return state;
  }
}
